var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.LogOut,{scopedSlots:_vm._u([{key:"activator",fn:function({ logout }){return [_c('v-btn',{staticClass:"profile-settings-logout-button",attrs:{"block":"","text":""},on:{"click":logout}},[_c('span',{staticClass:"text"},[_vm._v("Log Out")])])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }